/**
 * Site Name Configuration
 * Auto-generated from: KEYWORD + NICHE + COUNTRY
 * Format: {keyword} {niche} {country}
 * This file is auto-generated - do not edit manually
 * 
 * Generated at: 2026-01-29T17:52:53.562Z
 */

// Site name auto-generated from keyword, niche, and country
export const SITE_NAME = 'meet milf australia'

export default SITE_NAME
